<template>
  <NavButton text="Back" url="/"/>
  <div class="container">
        <div class="row">
            <div class="col">
                <h1>Privacy Policy</h1>
                <h2>Mobile watch face "Retro Digital Dash”</h2>
                <p>Last updated: March 3rd, 2023</p>
                <p>This privacy policy governs your use of the watch face “Retro Digital Dash Watch Face” (Later referred to as “The Application”) developed for Wear OS devices by Wesley Darnell.</p>
                <p>The Application is a mobile Wear OS watch face that displays general data selected and allowed by the user. Non-user selectable contents include: Time, date, battery percentage, and notification count. Permission must be granted at the device for complication data to be used.</p>
                <h1>What information does the Application obtain and how is it used?</h1>
                <h2>User Provided Information</h2>
                <p>The Application does not require any user registration. The Application does not require the user to provide any personal information.</p>
                <h2>Automatically Collected Information</h2>
                <p>The Application does not collect any information automatically.</p>
                <p>The Application does not share any information automatically with third parties.</p>
                <h1>Does the Application collect precise real time location information of the device?</h1>
                <p>The Application does not collect precise information about the location of your mobile device.</p>
                <h1>Do third parties see and/or have access to information obtained by the Application?</h1>
                <p>The Application does not collect any information automatically.</p>
                <p>The Application does not share any information.</p>
                <h1>What are my opt-out rights?</h1>
                <p>Users may uninstall the Application at any time. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>
                <h1>Data Retention Policy, Managing Your Information</h1>
                <p>This Application does not automatically collect, share, nor retain any information.</p>
                <h1>Does the Application contain ads?</h1>
                <p>This Application does not contain ads.</p>
                <h1>Target Age Group</h1>
                <p>This Application targets no specific age group. The target audience is owners of “Wear OS” smart watches.</p>
                <h1>Children</h1>
                <p>Our Application does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. We do not use the Application to knowingly solicit data from or market to children under the age of 13.</p>
                <h1>Changes</h1>
                <p>This Privacy Policy may be updated for any reason. We will notify you of any changes to our Privacy Policy by posting the new Privacy Policy at <a href="https://www.wesleydarnell.dev/privacypolicy">https://www.wesleydarnell.dev/privacypolicy</a> and updating the "Last updated" date at the top of this Privacy Policy.</p>
                <p>You are advised to review this Privacy Policy periodically for any changes. Continued use is deemed approval of all changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                <h1>Your Consent</h1>
                <p>By using the Application, you only consent to the local processing of your information.</p>
                <p>At any time, no User Provided Data will be shared, processed and/or stored by third parties.</p>
                <p>User Provided Data cannot and will never be sold to any other third parties.</p>
            </div>
        </div>
    </div>
 </template>

<script>
import NavButton from '@/components/NavButton.vue'
export default {
  name: 'PrivacyPolicy',
  data: function() {
    return {
    }
  },
  components: {
    NavButton
  }
}
</script>

<style>
    .container {
      padding-top: 30px;
    }
</style>

<style>
  @import '@/assets/styles/global.css';
</style>
<style>
  @import '@/assets/styles/variables.css';
</style>
